import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { hideModal, resetModal } from 'redux/modules/modal';
import { estimateCostOnAddUserSeats } from 'redux/modules/companies';
import PropTypes from 'prop-types';
import { isValidNonZeroQuantity, getMembersPaidQuantity } from '../../utils/subscription';
import _ from 'lodash';
import QuantityField from '../../components/QuantityField';
import ERRORS from '../../errors/errorids';
import AppError from '../../errors/apperror';

import {
	Grid,
	Dialog,
	DialogTitle,
	DialogContent,
	Button,
	Typography,
	Link,
	IconButton
} from '@material-ui/core';

import { XIcon, SpinnerIcon } from '../../theme/icons';
import {
	COUPON_TYPE,
	BUY_MORE_POPUP_TYPE,
	QUANTITY_TYPE,
	SUBSCRIPTION_PERIOD,
	SUBSCRIPTION_PRICES,
	SUBSCRIPTION_PLAN,
	PACKAGES_CONFIG
} from '../../config';
import PromoForm from '../../components/PromoForm';
import {
	trackBuyMoreSeatsPopupShown,
	trackBuyMoreLicensesPopupShown,
} from 'lib/Segment/customTrackers';
import { getTrackingOptions } from 'lib/Segment/helpers';

import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

const styles = theme => {
	return {
		/* Dialog */
		dialogPaper: {
			minWidth: 444
		},
		dialogWrapper: {
			position: 'relative',
			padding: '15px 10px',
			minHeight: 270
		},
		dialogTitle: {
			'& h6': {
				fontWeight: 600,
				fontSize: '28px',
				lineHeight: 1.4,
				marginBottom: 5,
				textAlign: 'left'
			}
		},
		/* close button */
		closeDialog: {
			position: 'absolute',
			top: 10,
			right: 10
		},
		closeDialogIcon: {
			color: '#6F99BD',
			width: '20px',
			height: '20px'
		},

		text: {
			textAlign: 'left',
			color: '#000',
			opacity: 1
		},

		/* price per license */
		priceGridElement: {
			textAlign: 'left'
		},
		pricePerLicense: {
			display: 'inline-block',
			marginBottom: 16,
			marginRight: 10,
		},
		couponCodeLink: {
			fontFamily: 'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',
			fontSize: 14,
			textDecoration: 'underline',
			'&:hover': {
				color: '#2888C3'
			}
		},
		showDiscountForm: {
		},
		changeDiscountForm: {
			display: 'block',
			marginTop: -6,
			marginBottom: 6
		},
		discountAppliedLabel: {
			fontFamily: '"Open Sans Xara", Arial, Helvetica, sans-serif',
			fontWeight: 'normal',
			fontSize: 14,
			lineHeight: 1.5,
			background: '#E1F4FD',
			color: '#2888C3',
			display: 'inline-block',
			padding: '1px 5px',
			opacity: 1,
			borderRadius: 5
		},
		seatsDiscountAppliedLabel: {
			marginLeft: 5,
			fontSize: 14,
			lineHeight: 1.5			
		},
		invalidDiscount: {
			display: 'inline-block',
			marginRight: 10,
			marginTop: 5,
			marginBottom: 18,
			color: theme.palette.colors.error
		},
		invalidCouponMessage: {
			marginRight: 10
		},
		/* promo form */
		promoFormGridElement: {
			marginBottom: 16
		},
		/* total users */
		totalUsersAfterPurchase: {
		},
		roleInfo: {
		},
		/* total price for seats */
		totalPriceforExtraSeats: {
			paddingTop: 20,
			paddingBottom: 10
		},
		/* quantity */
		quantityGridElement: {
		},
		/* total users */
		totalUsersGridElement: {
		},
		
		/* buttons */
		buttonsContainer: {
			paddingTop: 30
		},
		button: {
			fontFamily: 'Open Sans, sans-serif',
			borderRadius: 5,
			fontWeight: 600,
			fontSize: 18,
			lineHeight: 1.3,
			opacity: '1 !important',
			color: '#000',
			paddingLeft: 15,
			paddingRight: 15,
			minWidth: 'auto'
		},
		buttonCancel: {
		},
		buttonContinue: {
			background: theme.palette.primary.main,
			color: 'white',
			textShadow: 'none',
			'&[class*=contained][class*=disabled]': {
				backgroundColor: '#B3B9C0'
			},
			marginLeft: 10
		},
		/* error message */
		errorMessage:  {
			color: theme.palette.error.main,
			fontSize: 14,
			lineHeight: 1.5,
			opacity: 1,
			textAlign: 'left',
			marginTop: 0,
			marginBottom: 15,
			'& a': {
				color: theme.palette.primary.main
			}
		},
		/* loading icon */
		loadingWrapper: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)'
		},
		loadingMessage: {
			fontSize: 16,
			lineHeight: 1.5,
			opacity: 1
		},
		loadingIcon: {
			display: 'block',
			height: '24px',
			width: '24px',
			margin: '0 auto 10px',
			fill: '#96DCFD',
			animation: 'spin 2s linear infinite'
		},
		'@keyframes spin': {
			'0': {
				transform: 'rotate(0deg)'
			},
			'100%': {
				transform: 'rotate(360deg)'
			}
		},

		/* magix discount link */
		discountBannerContainer: {
			flexWrap: 'nowrap',
			marginBottom: 15
		},
		discountBannerQuestionColumn: {
		},
		discountBannerQuestion: {
			color: '#000',
			fontSize: 15,
			lineHeight: 1.2,
			opacity: 1,
		},
		discountBannerGetDiscountButtonColumn: {
			padding: '0 0 0 10px'
		},
		discountBannerLink: {
			fontSize: 14,
			color: '#000',
			lineHeight: 1.2,
			opacity: 1,
			fontWeight: 600,
			fontFamily: 'Lato, "Open Sans Xara", Arial, Helvetica, sans-serif',
			textTransform: 'uppercase'
		},			
	};
};

const errors = {
	[ERRORS.OFFLINE] : localize('subscriptions-error-offline'),
	[ERRORS.API_REQUEST_LIMIT_EXCEEDED] : localize('error-cb-api-rate-limit-reached')
};

@withStyles(styles)
class BuyMoreLicensesOrSeatsModal extends Component {

	constructor(props) {
		super(props);

		this.getEstimatedCostForSeatsDebounced = _.debounce(this.getEstimatedCostForSeats, 350);
		this.hasCouponError = this.hasCouponError.bind(this);

		this.state = {
			showPromoForm: false,
			inputFieldQuantity: this.getInputFieldQuantity(props.type),
			apiRequestError: false,
			apiRequestSuccess: false,
			xhrInProgress: false,
			fetchingSeatsCostEstimate: false,
			fetchingSeatsCostEstimateError: false,
			seatsCostEstimate: null,
			discountPercent: null,
			isTaxed: null,
			hasCouponError: false,
			errors: {}
		};
	}

	componentDidMount() {
		if (this.props.type === BUY_MORE_POPUP_TYPE.LICENSES) {
			trackBuyMoreLicensesPopupShown(this.props.plan, getTrackingOptions(this.props.company));
		} else {
			trackBuyMoreSeatsPopupShown(this.props.plan, getTrackingOptions(this.props.company));
			this.getEstimatedCostForSeats(this.state.inputFieldQuantity);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { type } = this.props;
		this.updateSeatsQuantity(prevProps, type);
	}

	updateSeatsQuantity(compareProps, type) {
		if (type === BUY_MORE_POPUP_TYPE.SEATS && (this.props.app.seatsQuantity !== compareProps.app.seatsQuantity ||
			this.props.app.isSeatsQuantityAutoApplied !== compareProps.app.isSeatsQuantityAutoApplied) ||
			
			type === BUY_MORE_POPUP_TYPE.LICENSES && (this.props.app.licensesQuantity !== compareProps.app.licensesQuantity ||
				this.props.app.isLicensesQuantityAutoApplied !== compareProps.app.isLicensesQuantityAutoApplied)
		) {
			const quantity = this.getInputFieldQuantity(type);

			this.setState({
				inputFieldQuantity: quantity
			});
			
			if (type === BUY_MORE_POPUP_TYPE.SEATS && isValidNonZeroQuantity(quantity)) {
				this.getEstimatedCostForSeatsDebounced(quantity);
			}
		}
	}
		
	componentWillReceiveProps(nextProps) {
		if (
			(this.props.companies.createChargeBeeSubscriptionErrorId !== nextProps.companies.createChargeBeeSubscriptionErrorId &&
			nextProps.companies.createChargeBeeSubscriptionErrorId !== null)
			||
			(this.props.companies.purchaseSeatsErrorId !== nextProps.companies.purchaseSeatsErrorId &&
				nextProps.companies.purchaseSeatsErrorId !== null)
		) {
			this.handleApiErrors(nextProps);
		}

		if ((this.props.companies.createChargeBeeSubscriptionSuccess 
			!== nextProps.companies.createChargeBeeSubscriptionSuccess &&
			nextProps.companies.createChargeBeeSubscriptionSuccess === true)
				||
			(this.props.companies.purchaseSeatsSuccess 
				!== nextProps.companies.purchaseSeatsSuccess &&
				nextProps.companies.purchaseSeatsSuccess === true)
		) {
			this.setState({
				xhrInProgress: false,
				apiRequestError: false,
				apiRequestSuccess: true,
				errors: { apiError: null }
			});			
		}		
	}	

	render() {
		const { modalShown, resetModal, classes } = this.props;

		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onExited={resetModal}
				BackdropProps={{ style: { backgroundColor: 'rgba(46, 63, 79, 0.4)' } }}
				classes={{ paper: classes.dialogPaper }}
				PaperProps={{
					style: {
						border: 0,
						width: 309,
						borderRadius: 5,
						boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.08)'
					}
				}}
			>
				<div className={classes.dialogWrapper}>
					<IconButton
						className={classes.closeDialog}
						component='span'
						aria-label='Close'
						onClick={() => this.closeDialog(false)}
					>
						<XIcon className={classes.closeDialogIcon} />
					</IconButton>
					{(() => {
						if (this.state.xhrInProgress) {
							return this.renderLoading();
						} else if (this.state.apiRequestSuccess) {
							this.closeDialog(true);							
						} else if (this.state.apiRequestError) {
							return this.renderForm();
						} else {
							return this.renderForm();
						}
					})()}
				</div>
			</Dialog>
		);
	}

	renderForm() {
		const { type, classes } = this.props;

		return (
			<Fragment>
				<DialogTitle
					variant='body1'
					color='default'
					className={classes.dialogTitle}>
					{localize(
							type === BUY_MORE_POPUP_TYPE.LICENSES
								?
								'subscription-extra-licenses-title'
								:
								'subscription-extra-users-title'
					)}
				</DialogTitle>
				<DialogContent>
					<Grid container direction="column">
						{Object.keys(this.state.errors).length > 0 && this.renderErrorMessage()}

						{type === BUY_MORE_POPUP_TYPE.LICENSES ? this.renderLicensesForm() : this.renderSeatsForm()}

						<Grid item container direction="row" justify="flex-end" className={classNames(classes.buttonsContainer)}>
							<Grid item>
								<Button
									variant='outlined'
									color='primary'
									data-tid="button-buy-more-modal-cancel"
									className={classNames(classes.button, classes.buttonCancel)}
									onClick={() => this.closeDialog(false)}
									disabled={false}>
									{localize('cancel')}
								</Button>
							</Grid>
							<Grid item>
								<Button
									variant='contained'
									color='primary'
									data-tid="button-buy-more-modal-save"
									className={classNames(classes.button, classes.buttonContinue)}
									onClick={() => this.submitForm()}
									disabled={!this.isFormValid()}>
									{type === BUY_MORE_POPUP_TYPE.LICENSES ? localize('continue') : localize('pay-now')}
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</DialogContent>
			</Fragment>
		);
	}

	renderLicensesForm() {
		const { currency, plan, classes } = this.props;
		const { showPromoForm } = this.state;
		const {
			isDiscountApplied,
			discountType,
			couponId,
			couponSetKey,
			couponConfig,
			couponType,
			appliedProdTypeOfLastValidCombination,
			appliedProdCatOfLastValidCombination			
		} = this.props.discount;

		const pricePerLicense = parseFloat(SUBSCRIPTION_PRICES[plan][SUBSCRIPTION_PERIOD.PERPETUAL]);
		let discountPrice;


		const showDiscount = isDiscountApplied &&
			this.props.shouldShowAppliedDiscountForCurrentPackage(
				plan,
				SUBSCRIPTION_PERIOD.PERPETUAL,
				currency.key,
				couponConfig,
				discountType,
				couponSetKey,
				couponId,
				false,
				appliedProdTypeOfLastValidCombination,
				appliedProdCatOfLastValidCombination);

		if (showDiscount) {
			discountPrice = this.props.getDiscountPrice(pricePerLicense, plan);
		}

		const nrOfQualifyingProductsForCouponInAllCurrencies = 
			this.props.getNumberOfQualifyingProductsForCoupon(true, false, false, plan);

		const nrOfQualifyingSubscriptions = 
			this.props.getNumberOfQualifyingProductsForCoupon(true, true, false);

		const nrOfQualifyingPerpetualProducts = 
			this.props.getNumberOfQualifyingProductsForCoupon(true, false, true);

		const invalidDiscount = isDiscountApplied && !showDiscount && couponType === COUPON_TYPE.LICENSES;

		let checkoutPrice = discountPrice || pricePerLicense;
		checkoutPrice = checkoutPrice.toFixed(2);

		return (
			<Fragment>
				<Grid item className={classes.priceGridElement}>
					<Typography variant="body1" className={classNames(classes.pricePerLicense, classes.text)}>
						{localize('subscription-extra-licenses-cost-per-license', [currency.symbol, checkoutPrice])}
					</Typography>

					{showDiscount && 
							(<Typography className={classes.discountAppliedLabel}>
								{localize('subscription-extra-licenses-discount-applied')}
							</Typography>)}

					{!showPromoForm && !showDiscount && !invalidDiscount && (
						<Link
							underline='hover'
							data-tid={'button-discount-banner'}
							onClick={() => this.showDiscountForm()}
							className={classNames(classes.couponCodeLink, classes.showDiscountForm)}
						>
							{localize('subscription-extra-licenses-discount-use')}
						</Link>
					)}		

					{!showPromoForm && showDiscount && (
						<Link
							underline='hover'
							data-tid={'button-discount-banner'}
							onClick={() => this.resetDiscountForm()}
							className={classNames(classes.couponCodeLink, classes.changeDiscountForm)}
						>
							{localize('subscription-extra-licenses-change-coupon')}
						</Link>
					)}
					
					{!showPromoForm && !showDiscount && (
						<Grid
							container
							direction="row"
							className={classNames(classes.discountBannerContainer)}>
							<Grid item className={classes.discountBannerQuestionColumn}>
								<Typography
									variant='body2'
									className={classes.discountBannerQuestion}
									dangerouslySetInnerHTML={{ __html: localize('subscription-discount-magix') }}
								/>
							</Grid>
							<Grid item className={classes.discountBannerGetDiscountButtonColumn}>
								<Link
									underline='hover'
									data-tid={'button-discount-banner'}
									className={classNames(classes.discountBannerGetDiscountButton,
														classes.discountBannerLink)}
									onClick={() => this.props.routeToOneTimeCheckBoxAndShowDiscountPopup()}
								>
									{localize('subscription-discount-get')}
								</Link>					
							</Grid>
						</Grid>
					)}
				</Grid>
				
				{showPromoForm && <Grid item className={classNames(classes.promoFormGridElement)}>
					<PromoForm
						type={COUPON_TYPE.LICENSES}
						currency={this.props.currency}
						nrOfQualifyingProductsForCoupon={showDiscount ? 1 : 0}
						nrOfQualifyingProductsForCouponInAllCurrencies={nrOfQualifyingProductsForCouponInAllCurrencies}
						nrOfQualifyingSubscriptions={nrOfQualifyingSubscriptions}
						nrOfQualifyingPerpetualProducts={nrOfQualifyingPerpetualProducts}
						getQualifyingProductsForCoupon={this.props.getQualifyingProductsForCoupon}
						addVersionToTitle={this.props.addVersionToTitle}
						plan={this.props.plan}
						handleSwitchToPlansFromBuyMoreLicensesPopup={this.props.handleSwitchToPlansFromBuyMoreLicensesPopup}
						contactUsHandler={this.props.contactUsHandler}
						hasCouponError={this.hasCouponError}
					/>
				</Grid>}

				<Grid item className={classes.quantityGridElement}>
					<QuantityField
						quantity={this.state.inputFieldQuantity}
						renderInfoTooltip={this.props.renderInfoTooltip}
						quantityType={this.props.type}
						isBuyMorePopup={true} />
				</Grid>				
			</Fragment>
		);
	}
	
	renderSeatsForm() {

		const { currency, plan, classes, period } = this.props;
		const {
			seatsCostEstimate,
			discountPercent,
			fetchingSeatsCostEstimate,
			fetchingSeatsCostEstimateError,
			isTaxed
		} = this.state;
		
		const renderCostEstimate = () => {
			if (seatsCostEstimate !== null) {
				return (
					<Fragment>
						{currency.symbol}{seatsCostEstimate} / {localize(period === SUBSCRIPTION_PERIOD.ANNUAL
							?
							'subscription-billing-year'
							:
							'subscription-billing-month')} {isTaxed && `(${localize('subscription-including-vat')})`}

						{discountPercent && 
							(<span className={classNames(classes.discountAppliedLabel, classes.seatsDiscountAppliedLabel)}>
								{discountPercent}% {localize('subscription-extra-users-seat-discount-applied')}
							</span>)}
					</Fragment>
				);
			} else if (fetchingSeatsCostEstimate) {
				return localize('subscription-extra-users-calculating-total');
			} else if (fetchingSeatsCostEstimateError) {
				return (this.props.companies.estimateCostOnAddUserSeatsErrorId &&
					errors[this.props.companies.estimateCostOnAddUserSeatsErrorId]) ||
				localize('subscription-extra-users-error-calculating');
			}
		};

		const totalNumberOfUserLicenses = this.props.companies.pendingPayingUserQuantity
			?
			parseInt(this.state.inputFieldQuantity) +
			this.props.companies.pendingPayingUserQuantity
			:
			parseInt(this.state.inputFieldQuantity) +
			getMembersPaidQuantity(this.props.company) +
			PACKAGES_CONFIG[plan].freeSeatsIncluded;

		return (
			<Fragment>
				<Grid item className={classes.quantityGridElement}>
					<QuantityField
						quantity={this.state.inputFieldQuantity}
						renderInfoTooltip={this.props.renderInfoTooltip}
						plan={plan}
						quantityType={this.props.type}
						enableBulkDiscountTooltip={true}
						isBuyMorePopup={true} />
				</Grid>
				{this.isFormValid() && (
					<Fragment>
						<Grid item className={classes.totalUsersGridElement}>
							<Typography variant="body1" className={classNames(classes.totalUsersAfterPurchase, classes.text)}>
								{localize('subscription-extra-users-total-users-after-purchase', totalNumberOfUserLicenses)}
							</Typography>
							{
								[SUBSCRIPTION_PLAN.TEAM_PLUS, SUBSCRIPTION_PLAN.ESSENTIAL].includes(plan) && 
							<Typography variant="body1" className={classNames(classes.roleInfo, classes.text)}>
								{localize('subscription-extra-users-admin-member-usage')}
							</Typography>
							}
						</Grid>

						<Grid item className={classes.totalUsersGridElement}>
							<Typography variant="body1" className={classNames(classes.totalPriceforExtraSeats, classes.text)}>
								<span>{localize('subscription-extra-users-total-until-renewal')}:&nbsp;</span>
								<span>{renderCostEstimate()}</span>
							</Typography>
						</Grid>
					</Fragment>
				)}
			</Fragment>
		);		
	}

	getInputFieldQuantity(type) {
		return this.props.getQuantityInputValue(
			type === BUY_MORE_POPUP_TYPE.SEATS ? QUANTITY_TYPE.SEATS : QUANTITY_TYPE.LICENSES
		);
	}	

	closeDialog(closeDuringCheckout) {
		this.props.clearInvalidFieldsForBuyMorePopup(true,
			!closeDuringCheckout && this.state.hasCouponError);
		this.props.hideModal();
	}

	renderLoading() {
		const { classes } = this.props;
		return (
			<div className={classes.loadingWrapper}>
				<SpinnerIcon className={classes.loadingIcon} />
				<Typography className={classes.loadingMessage} variant="body2">
					{localize('subscriptions-modal-fetching-data')}
				</Typography>
			</div>
		);
	}	

	renderErrorMessage() {
		const errorMessage = _.get(this.state, 'errors.apiError');
		const { classes } = this.props;
		return (
			<Typography className={classes.errorMessage} variant="body2" dangerouslySetInnerHTML={{ __html: errorMessage }} />
		);		
	}

	handleApiErrors(nextProps) {
		if (nextProps.companies.createChargeBeeSubscriptionErrorId || nextProps.companies.purchaseSeatsErrorId) {
			const errorMessage = nextProps.companies.createChargeBeeSubscriptionErrorId &&
				errors[nextProps.companies.createChargeBeeSubscriptionErrorId] || 
				nextProps.companies.purchaseSeatsErrorId &&
				errors[nextProps.companies.purchaseSeatsErrorId] || 				
				localize('subscriptions-error-unknown');

			this.setState({
				xhrInProgress: false,
				apiRequestError: true,
				apiRequestSuccess: false,
				errors: { apiError: errorMessage }
			});
		}
	}

	isFormValid() {
		return isValidNonZeroQuantity(this.state.inputFieldQuantity);
	}

	
	hasCouponError(value) {
		this.setState({
			hasCouponError: value
		});
	}

	showDiscountForm() {
		this.setState({
			showPromoForm: true
		});
	}

	resetDiscountForm() {
		this.setState({
			showPromoForm: true
		});
	}

	getEstimatedCostForSeats(quantity) {

		this.setState({
			fetchingSeatsCostEstimate: true
		});

		this.props.estimateCostOnAddUserSeats(quantity)
			.then((data) => {
				if (data instanceof AppError) {
					this.setState({
						fetchingSeatsCostEstimate: false,
						fetchingSeatsCostEstimateError: true,
						seatsCostEstimate: null,
						discountPercent: null,
						isTaxed: null
					});
			
					return;
				}
		
				const {
					amount,
					discountAmountWithoutTax,
					amountWithoutTaxAndWithoutDiscount,
					amountWithoutTaxAndWithDiscount,
					taxRate
				} = data.result;

				let discountPercent;
				if (discountAmountWithoutTax && amountWithoutTaxAndWithoutDiscount && amountWithoutTaxAndWithDiscount) {
					discountPercent = Math.ceil((1-amountWithoutTaxAndWithDiscount/amountWithoutTaxAndWithoutDiscount) * 100);
				}

				this.setState({
					fetchingSeatsCostEstimate: false,
					fetchingSeatsCostEstimateError: false,
					seatsCostEstimate: amount ? (amount/100).toFixed(2) : 0,
					discountPercent,
					isTaxed: taxRate !== null
				});
			});		
	}

	submitForm() {
		this.setState({
			xhrInProgress: true,
			apiRequestError: false,
			apiRequestSuccess: false,
			errors: { apiError: null }
		});				
		this.props.cb(this.state.hasCouponError);
	}
}

BuyMoreLicensesOrSeatsModal.propTypes = {
	companies: PropTypes.object,
	modalShown: PropTypes.bool,
	hideModal: PropTypes.func,
	resetModal: PropTypes.func,
	classes: PropTypes.object,
	plan: PropTypes.string,
	type: PropTypes.string,
	currency: PropTypes.object,
	discount: PropTypes.object.isRequired,
	cb: PropTypes.func,
	shouldShowAppliedDiscountForCurrentPackage: PropTypes.func,
	getNumberOfQualifyingProductsForCoupon: PropTypes.func,
	getQualifyingProductsForCoupon: PropTypes.func,
	getDiscountPrice: PropTypes.func,
	getQuantityInputValue: PropTypes.func,
	clearInvalidFieldsForBuyMorePopup: PropTypes.func, 
	renderInfoTooltip: PropTypes.func,
	app: PropTypes.object.isRequired,
	nrOfNonGuestUsers: PropTypes.number,
	period: PropTypes.string,
	estimateCostOnAddUserSeats: PropTypes.func, 
	company: PropTypes.object,
	contactUsHandler: PropTypes.func, 
	addVersionToTitle: PropTypes.func,
	handleSwitchToPlansFromBuyMoreLicensesPopup: PropTypes.func,
	routeToOneTimeCheckBoxAndShowDiscountPopup: PropTypes.func,
};

const mapStateToProps = state => ({
	modalShown: state.modal.modalShown,
	discount: state.discount,
	companies: state.companies,
	app: state.app,
	company: state.companies.rawDataById[state.companies.selectedId]
});

const mapDispatchToProps = dispatch => bindActionCreators({
	estimateCostOnAddUserSeats,
	hideModal,
	resetModal,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(BuyMoreLicensesOrSeatsModal);


// WEBPACK FOOTER //
// ./src/components/Modal/BuyMoreLicensesOrSeatsModal.js